import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { isDisabled } from "@testing-library/user-event/dist/utils";
import * as React from "react";
import { useState } from "react";
import { createPortal } from "react-dom";
import { createRoot, Root } from "react-dom/client";
import { boolean } from "zod";

interface OpenArgs<T> {
  onHide: () => void;
  /* children: React.ReactElement<{
    resolve?: (value: T | PromiseLike<T> | K | PromiseLike<K>) => void;
    hide: () => void;
    confirmValue: T;
    cancelValue: K;
  }>; */
  children: React.ReactElement<{
    resolve?: (value: T | PromiseLike<T>) => void;
    onValidate?: (value: boolean) => void;
  }>;
  cancelValue: T;
  confirmValue: T;
  okButtonName?: string;
  cancelButtonName?: string;
  hideCancelButton?: boolean;
}

const asyncModalRoot = document.getElementById("modal-root") as HTMLElement;

let root: Root | null = null;
const dialogHeader = "CSM Shopfloor";
const firstPosition = { X: 600, Y: 25 };

const AsyncModal = {
  open: <T,>({
    children,
    onHide,
    cancelValue,
    confirmValue,
    okButtonName,
    cancelButtonName,
    hideCancelButton,
  }: OpenArgs<T>) =>
    new Promise<T>((resolve) => {
      if (!root && asyncModalRoot) {
        // Create a root
        root = createRoot(asyncModalRoot);
      }

      const hide = () => {
        root?.unmount();
        root = null;
      };

      let currentValue: T = confirmValue;

      const onValidate = (failed: boolean, value?: any) => {
        const btn = document.getElementsByClassName(
          "e-control e-btn e-lib e-flat e-primary"
        )[0]; // as HTMLElement;
        console.log(`validate  ${failed} ${btn.innerHTML}`);

        if (failed) {
          btn.setAttribute("disabled", "disabled");
        } else {
          btn.removeAttribute("disabled");
        }

        if (value) {
          currentValue = value;
        }
      };

      // const onCloseButtonClicked = () => {
      //   hide();
      //   onHide();
      //   resolve(cancelValue);
      // };

      const buttons =
        hideCancelButton === true
          ? [
              {
                buttonModel: {
                  id: "okButton",
                  content: okButtonName ?? "OK",
                  cssClass: "e-flat",
                  isPrimary: true,
                },
                click: () => {
                  hide();
                  onHide();
                  //setIsVisible(false);
                  resolve(currentValue);
                },
              },
            ]
          : [
              {
                buttonModel: {
                  id: "okButton",
                  content: okButtonName ?? "OK",
                  cssClass: "e-flat",
                  isPrimary: true,
                },
                click: () => {
                  hide();
                  onHide();
                  //setIsVisible(false);
                  resolve(currentValue);
                },
              },
              {
                buttonModel: {
                  content: cancelButtonName ?? "Cancel",
                  cssClass: "e-flat",
                  isPrimary: false,
                },
                click: () => {
                  hide();
                  onHide();
                  //setIsVisible(false);
                  resolve(cancelValue);
                },
              },
            ];

      root?.render(
        createPortal(
          <DialogComponent
            width="400px"
            close={() => resolve(cancelValue)}
            header={dialogHeader}
            //visible={isVisible}
            visible
            showCloseIcon={true}
            buttons={buttons}
            position={firstPosition}
            isModal
          >
            {/* {React.cloneElement(children, { resolve, hide, cancelValue })} */}
            {React.cloneElement(children, { resolve, onValidate })}
          </DialogComponent>,
          asyncModalRoot
        )
      );
    }),
};

export default AsyncModal;
